import { motion } from "framer-motion";

const lines = ["Everyday care,", "made simple."];

const lineVariants = {
  hidden: { y: "110%" },
  visible: (i) => ({
    y: 0,
    transition: { duration: 0.9, delay: 0.1 + i * 0.13, ease: [0.22, 1, 0.36, 1] },
  }),
};

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const Hero = () => (
  <section
    className="relative overflow-hidden bg-[#EDE3D6] bg-cover bg-[position:75%_center] lg:bg-[position:right_center]"
    style={{ backgroundImage: "url(/images/hero-beauty.webp)" }}
    data-testid="hero-section"
  >
    <div className="absolute inset-0 bg-gradient-to-r from-[#F8F4EC]/95 from-0% via-[#F8F4EC]/60 via-45% to-transparent to-85% sm:hidden pointer-events-none" aria-hidden />
    <div className="absolute inset-0 hidden sm:block bg-gradient-to-r from-[#F8F4EC]/90 from-0% via-[#F8F4EC]/45 via-32% to-transparent to-55% pointer-events-none" aria-hidden />

    <div className="max-w-7xl mx-auto px-6 sm:px-10 grid lg:grid-cols-12 gap-10 items-center pt-32 pb-24 lg:pt-40 lg:pb-36 min-h-[88vh]">
      <div className="lg:col-span-7 relative z-10">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.05 }}
          className="font-mono-accent text-xs uppercase tracking-[0.3em] text-[#C9A45C] mb-6"
          data-testid="hero-overline"
        >
          CELUSTA
        </motion.p>

        <h1 className="font-serif-display font-medium text-5xl sm:text-6xl lg:text-7xl leading-[1.02] tracking-tight text-[#2B1F1B]" data-testid="hero-heading">
          {lines.map((line, i) => (
            <span key={line} className="block overflow-hidden pb-1">
              <motion.span
                className={`block ${i === 1 ? "italic text-[#3A2A25]" : ""}`}
                variants={lineVariants}
                initial="hidden"
                animate="visible"
                custom={i}
              >
                {line}
              </motion.span>
            </span>
          ))}
        </h1>

        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.7 }}
          className="mt-8 max-w-md text-lg font-light leading-relaxed text-[#756A64]"
          data-testid="hero-subtext"
        >
          Thoughtful essentials for hair, body and everyday beauty.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.9 }}
          className="mt-10 flex flex-wrap items-center gap-4"
        >
          <button
            onClick={() => scrollTo("shop")}
            className="px-10 py-4 bg-[#3A2A25] text-white text-xs font-semibold uppercase tracking-[0.2em] rounded-full hover:bg-[#55423A] hover:-translate-y-0.5 hover:shadow-[0_12px_30px_rgba(58,42,37,0.25)] transition-[background-color,transform,box-shadow] duration-300"
            data-testid="hero-shop-hair-button"
          >
            Shop Hair
          </button>
          <button
            onClick={() => scrollTo("body-care")}
            className="px-10 py-4 border border-[#3A2A25]/40 text-[#3A2A25] text-xs font-semibold uppercase tracking-[0.2em] rounded-full hover:bg-[#3A2A25] hover:text-white hover:-translate-y-0.5 transition-[background-color,color,transform] duration-300"
            data-testid="hero-shop-body-button"
          >
            Shop Body
          </button>
        </motion.div>
      </div>
    </div>
  </section>
);
